import store from 'config/store'
import produce from 'immer'
import { DRIFT_VISIT_COUNTS } from 'shared/constants/localStorage'
import { DRIFT_SESSION_ID } from 'shared/constants/session'
import spacetime from 'spacetime'
import { broadcast } from 'utils/message'
import { localStore, sessionStore } from 'utils/storage'

import { receiveVisitInformation } from './actions'

export const countSiteVisit = async function () {
  const { data: hostLocation = {} } = await broadcast({
    topic: 'access-host-window',
    message: { key: 'location' }
  })

  const { data: previousVisits } = await localStore.get(DRIFT_VISIT_COUNTS)
  const { data: sessionId } = await sessionStore.get(DRIFT_SESSION_ID)
  const existingPreviousVisits = previousVisits || {}

  const getSessionCount = (draft) => {
    if (!draft.lastSessionId) {
      return 1
    }

    if(draft.lastSessionId !== sessionId) {
      return draft.total + 1
    }

    return draft.total
  }

  const updatedVisitCounts = produce(existingPreviousVisits, (draft) => {
    draft.total = getSessionCount(draft)
    draft.daysSinceLastVisit = spacetime.now().since(draft.lastVisit || spacetime.now()).diff.days
    draft.lastVisit = spacetime.now().epoch
    draft.firstVisit = draft.firstVisit || spacetime.now().epoch
    draft.lastSessionId = sessionId
    draft[hostLocation.pathname] = (draft[hostLocation.pathname] || 0) + 1
  })

  localStore.set(DRIFT_VISIT_COUNTS, updatedVisitCounts)
  store.dispatch(receiveVisitInformation(updatedVisitCounts))
}
